import { Loader2 } from "lucide-react";

const TOOL_LABELS: Record<string, string> = {
  score_locations: "Scoring locations",
  switch_profile: "Switching profile",
  filter_locations: "Filtering locations",
  upload_csv: "Requesting upload",
  compare_profiles: "Comparing profiles",
  export_results: "Exporting results",
  adjust_weights: "Adjusting weights",
  summarize_results: "Summarizing results",
  list_profiles: "Loading profiles",
  create_campaign: "Creating campaign",
};

interface ToolCallCardProps {
  toolName: string;
  state: string;
}

export function ToolCallCard({ toolName, state }: ToolCallCardProps) {
  const isDone = state === "output-available";

  // Hide completely once the tool is done — the AI's text response replaces it
  if (isDone) return null;

  const label = TOOL_LABELS[toolName] ?? toolName;

  return (
    <div className="my-1.5 flex items-center gap-2 rounded-md bg-muted/50 px-3 py-2 text-xs text-muted-foreground">
      <Loader2 className="h-3.5 w-3.5 shrink-0 animate-spin" />
      <span>{label}...</span>
    </div>
  );
}
